module.exports = __webpack_public_path__ + "img/undraw_Target_re_fi8j.db9134af.png";